/* unplugin-vue-components disabled */import { render } from "./CreatePassword.vue?vue&type=template&id=e352acc8&scoped=true&ts=true"
import script from "./CreatePassword.vue?vue&type=script&lang=ts"
export * from "./CreatePassword.vue?vue&type=script&lang=ts"

import "./CreatePassword.vue?vue&type=style&index=0&id=e352acc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e352acc8"]])

export default __exports__